'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isIphone = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i);
var isIpad = navigator.userAgent.match(/iPad/i);
var isAndroid = navigator.userAgent.match(/Android/i);
var isMobile = isIphone || isIpad || isAndroid;
var isDesktop = !isMobile;

document.body.classList.add(isMobile ? 'mobile' : 'desktop');

var browser = { isIphone: isIphone, isIpad: isIpad, isAndroid: isAndroid, isMobile: isMobile, isDesktop: isDesktop };

function clamp(n, a, b) {
  return n < a ? a : n < b ? n : b;
}
function mod(n, m) {
  return n - m * Math.floor(n / m);
}
function choice(a) {
  return a[randint(a.length)];
}
function randint(n) {
  return Math.floor(Math.random() * n);
}
function randrange(a, b) {
  return Math.random() * (b - a) + a;
}
function firstTouch(f) {
  return function (e) {
    e.preventDefault();f(e.touches[0]);
  };
}

exports.browser = browser;
exports.clamp = clamp;
exports.mod = mod;
exports.choice = choice;
exports.randint = randint;
exports.randrange = randrange;
exports.firstTouch = firstTouch;


//////////////////
// WEBPACK FOOTER
// ./client/vendor/util.js
// module id = 68
// module chunks = 0